export const ENV = {
  OPTIMIZELY_KEY: '9BBxgNp9FvLu34jwvmSzX',
  LOG_METHOD: 'setLogLevel',
  LOG_LEVEL: 'info',
};
